function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1299",
  "data-name": "Rectangle 1299",
  width: 64,
  height: 64,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1007",
  "data-name": "Path 1007",
  d: "M66.843,337.045H82.324a1.148,1.148,0,0,0,1.079-1l.243-1.328a1.147,1.147,0,0,1,1.079-1h8.848a1.222,1.222,0,0,1,1.079,1.512l-.055.3a1.221,1.221,0,0,0,1.079,1.512H109.13a1.221,1.221,0,0,1,1.078,1.512L103.777,373.7a1.148,1.148,0,0,1-1.078,1l-42.291.022a1.221,1.221,0,0,1-1.08-1.512l6.437-35.167A1.147,1.147,0,0,1,66.843,337.045Z",
  transform: "translate(-50.933 -333.006)",
  fill: "#e5e9ed"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1010",
  "data-name": "Path 1010",
  d: "M60.1,375.121a1.742,1.742,0,0,1-1.353-.666,2.1,2.1,0,0,1-.419-1.7l6.435-35.143a1.862,1.862,0,0,1,1.772-1.591H82.015a.447.447,0,0,0,.385-.408l.243-1.326a1.862,1.862,0,0,1,1.772-1.591h8.847a1.744,1.744,0,0,1,1.354.668,2.106,2.106,0,0,1,.418,1.7l-.055.3a.636.636,0,0,0,.117.508.348.348,0,0,0,.267.143h13.451a1.745,1.745,0,0,1,1.355.668,2.1,2.1,0,0,1,.418,1.7l-6.431,35.121a1.861,1.861,0,0,1-1.77,1.59l-42.283.022Zm6.436-37.654a.447.447,0,0,0-.385.407l-6.435,35.144a.635.635,0,0,0,.117.509.348.348,0,0,0,.267.143h0l42.283-.023a.446.446,0,0,0,.385-.407l6.431-35.121a.635.635,0,0,0-.118-.508.347.347,0,0,0-.268-.144H95.364a1.742,1.742,0,0,1-1.354-.668,2.1,2.1,0,0,1-.418-1.7l.055-.3a.633.633,0,0,0-.118-.508.347.347,0,0,0-.267-.144H84.416a.448.448,0,0,0-.386.408l-.242,1.327a1.863,1.863,0,0,1-1.772,1.59Z",
  transform: "translate(-50.623 -332.691)",
  fill: "#c6ccd3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1011",
  "data-name": "Path 1011",
  d: "M89.626,345.5H75.771a1.06,1.06,0,0,0-1.026,1.282l.055.267a1.06,1.06,0,0,1-1.026,1.281l-8.446,0a1.052,1.052,0,0,1-1.026-.847l-.233-1.132a1.051,1.051,0,0,0-1.026-.847H49.292a1.06,1.06,0,0,0-1.026,1.282L54.4,376.648a1.053,1.053,0,0,0,1.026.847l40.337.019a1.06,1.06,0,0,0,1.027-1.281l-6.139-29.886A1.052,1.052,0,0,0,89.626,345.5Z",
  transform: "translate(-47.543 -335.795)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1012",
  "data-name": "Path 1012",
  d: "M95.455,377.91l-40.339-.019a1.765,1.765,0,0,1-1.711-1.413L47.27,346.611a1.786,1.786,0,0,1,.354-1.482,1.731,1.731,0,0,1,1.358-.656H62.734a1.763,1.763,0,0,1,1.712,1.413l.232,1.133a.351.351,0,0,0,.34.281l8.445,0a.342.342,0,0,0,.27-.13.354.354,0,0,0,.071-.3l-.055-.268a1.788,1.788,0,0,1,.354-1.481,1.731,1.731,0,0,1,1.358-.656H89.316a1.764,1.764,0,0,1,1.712,1.413l6.139,29.887a1.79,1.79,0,0,1-.355,1.483A1.733,1.733,0,0,1,95.455,377.91ZM48.983,345.9a.341.341,0,0,0-.27.13.351.351,0,0,0-.071.294l6.136,29.868a.351.351,0,0,0,.34.28l40.337.019a.343.343,0,0,0,.27-.13.352.352,0,0,0,.07-.3l-6.138-29.886a.35.35,0,0,0-.34-.28H75.462a.342.342,0,0,0-.27.13.35.35,0,0,0-.071.293l.055.269a1.789,1.789,0,0,1-.356,1.483,1.732,1.732,0,0,1-1.357.655l-8.446,0a1.763,1.763,0,0,1-1.711-1.413l-.233-1.133a.35.35,0,0,0-.34-.28Z",
  transform: "translate(-47.233 -335.48)",
  fill: "#c6ccd3"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_428-2",
  "data-name": "Group 428",
  transform: "translate(710 251.335)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_935",
  "data-name": "Path 935",
  d: "M74.275,177.469A8.322,8.322,0,1,0,82.6,185.79,8.321,8.321,0,0,0,74.275,177.469Z",
  transform: "translate(-65.953 -177.469)",
  fill: "#d5dae0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_936",
  "data-name": "Path 936",
  d: "M76.405,184.581l3.869,3.668h-2.5V191.4H74.449v-3.155h-2.5l3.869-3.668A.432.432,0,0,1,76.405,184.581Z",
  transform: "translate(-67.792 -179.615)",
  fill: "#fff"
}));

var SvgIllustrationFolderDisabled = function SvgIllustrationFolderDisabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration_Upload_-_Diabled",
    "data-name": "Illustration Upload - Diabled",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(-708 -212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(710 220)"
  }, _ref3, /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M94.945,346.525H80.988a1.062,1.062,0,0,0-1.034,1.282l.056.267a1.063,1.063,0,0,1-1.035,1.282l-8.508,0a1.058,1.058,0,0,1-1.033-.847l-.234-1.132a1.058,1.058,0,0,0-1.034-.847H54.313a1.062,1.062,0,0,0-1.034,1.282l6.181,29.867a1.057,1.057,0,0,0,1.033.847l40.517-.558c.67,0,1.027-.217.89-.879l-5.922-29.712A1.057,1.057,0,0,0,94.945,346.525Z",
    transform: "translate(-49.08 -336.109)",
    fill: "#c6ccd3",
    opacity: 0.48,
    style: {
      isolation: "isolate"
    }
  }), _ref4, _ref5, _ref6), _ref7));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustrationFolderDisabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration_folder_disabled.66e1b7cd.svg";
export { ForwardRef as ReactComponent };